import { render, staticRenderFns } from "./selectMenu.vue?vue&type=template&id=0518ba94&scoped=true"
import script from "./selectMenu.vue?vue&type=script&lang=js"
export * from "./selectMenu.vue?vue&type=script&lang=js"
import style0 from "./selectMenu.vue?vue&type=style&index=0&id=0518ba94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518ba94",
  null
  
)

export default component.exports